import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { ToyotaImporterResidualsOptions, ToyotaImporterIncentivesOptions } from "../models/lease-residuals";

const api = "/v1/config";
const routes = {
  triggerResidualsImport: `${api}/toyotaImporter/residuals`,
  triggerIncentivesImport: `${api}/toyotaImporter/incentives`
};

@Injectable({
  providedIn: "root"
})
export class ToyotaImporterService {

  constructor(private http: HttpClient) { }

  // HTTP

  triggerToyotaResidualsImport(options: ToyotaImporterResidualsOptions): Observable<any> {
    return this.http.post(routes.triggerResidualsImport, options);
  }

  triggerToyotaIncentivesImport(options: ToyotaImporterIncentivesOptions): Observable<any> {
    return this.http.post(routes.triggerIncentivesImport, options);
  }
}
